import { render, staticRenderFns } from "./ExtensionSummary.vue?vue&type=template&id=3b238abd"
import script from "./ExtensionSummary.vue?vue&type=script&lang=js"
export * from "./ExtensionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports